var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "well ovx-auto" },
    [
      _c("div", { staticClass: "flex-level" }, [
        _c("div", { staticClass: "flex fs-4 bold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Services liés par le time tracking")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex aright" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.impact_profit"),
                type: "secondary",
                disabled: _vm.impactButtonIsDisable
              },
              on: {
                click: function($event) {
                  return _vm.impact()
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "documents.overview.tab.margin.TimeTracking.quick_entry"
                ),
                type: "secondary",
                disabled: !_vm.canImpact,
                onclick:
                  "TimetrackingEntry.addFromDoc('" +
                  _vm.doctype +
                  "', " +
                  _vm.docid +
                  ");"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.timetrackings },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              selectable: _vm.canProcess,
              property: "processMargin"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.impact_profit") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.displaySaasBoolean(scope.row.processMargin)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: _vm.$t.__("common.labels.date") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$filters.saasDateFormatted(scope.row.date)) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "staff",
              label: _vm.$t.__("common.labels.staff")
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "service",
              label: _vm.$t.__(
                "documents.overview.tab.margin.TimeTracking.service"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "documents.overview.tab.margin.TimeTracking.hourly_cost_excluding_tax"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(scope.row.cost)
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "time",
              label: _vm.$t.__(
                "documents.overview.tab.margin.TimeTracking.declared_time"
              )
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "documents.overview.tab.margin.TimeTracking.total_cost_excluding_tax"
              )
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(
                            scope.row.totalAmount
                          )
                        ) +
                        "\n            "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.canImpact
            ? _c("el-table-column", {
                attrs: { fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "a",
                            {
                              staticClass: "link mr-2",
                              on: {
                                click: function($event) {
                                  return _vm.removeLink(scope.row, _vm.context)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$l10n.__("Délier")) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3847650210
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.timetrackings.length > 0
        ? _c("div", { staticClass: "aright fs-3 mt-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Total impact")) +
                " : " +
                _vm._s(_vm.$filters.numberFormatCurrency(_vm.formattedTotal)) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }